import { IMerchant } from '../types/merchant'
import { IUser, UserRole } from '../types/user'

export enum EUserRole {
  USER = 'user',
  ADMIN = 'admin',
  GHOST = 'ghost',
  MERCHANT = 'merchant',
  CUSTOMER = 'customer',
  HEAD = 'head',
  ADVERTISER = 'advertiser',
  SUPER_ADMIN = 'superAdmin',
  NEW_FEATURE = 'newFeature',
}

export const UserRoleLists = [
  {
    label: 'พนักงาน',
    value: UserRole.USER,
  },
  {
    label: 'คนยิงแอด',
    value: UserRole.ADVERTISER,
  },
  {
    label: 'หัวหน้าแอดมิน',
    value: UserRole.HEAD,
  },
  {
    label: 'ผู้ดูแลระบบ',
    value: UserRole.ADMIN,
  },
]

export const UserRoleMapper = {
  USER: 'พนักงาน',
  ADVERTISER: 'คนยิงแอด',
  HEAD: 'หัวหน้าแอดมิน',
  ADMIN: 'ผู้ดูแลระบบ',
  MERCHANT: 'ผู้ประกอบการ',
}

export const AbilitiesPermissions = [
  {
    label: 'รายการ CRM',
    subject: 'CRM',
    fields: [
      {
        label: 'Lead Pipeline',
        value: 'pipeline',
      },
      {
        label: 'นำเข้า Lead จากคำสั่งซื้อ',
        value: 'importLead',
      },
      {
        label: 'รายการติดตามทั้งหมด',
        value: 'allFollow',
      },
      {
        label: 'รายการติดตาม (ยกเลิก)',
        value: 'cancelFollow',
      },
      {
        label: 'รายการแจ้งเตือนติดตามลูกค้า',
        value: 'notificationFollow',
      },
      {
        label: 'ปฎิทินติดตามลูกค้า',
        value: 'calendarFollow',
      },
      {
        label: 'รายงานสถานะการติดตาม Lead',
        value: 'reportFollow',
      },
    ],
  },
  {
    label: 'รายการ รายงาน',
    subject: 'Report',
    fields: [
      {
        label: 'รายงานยอดขาย',
        value: 'sale',
      },
      {
        label: 'รายงานการสั่งของ',
        value: 'order',
      },
      {
        label: 'รายงานประจำวัน',
        value: 'daily',
      },
      {
        label: 'รายงานคอมมิชชั่น (ทั้งหมด)',
        value: 'commission',
      },
      {
        label: 'รายงานคอมมิชชั่น (ไม่แสดงยอดขายและค่าคอม)',
        value: 'commissionLimit',
      },
      {
        label: 'รายงานส่งของ',
        value: 'delivery',
      },
      {
        label: 'ปฏิทินรายงานส่งของ',
        value: 'calendar',
      },
      {
        label: 'ตรวจสอบยอด COD',
        value: 'cod',
      },
      {
        label: 'รายงานยอดขายลูกค้ารายบุคคล',
        value: 'customer',
      },
    ],
  },
  {
    label: 'รายการสร้างคำสั่งซื้อ',
    subject: 'CreateOrder',
    fields: [
      {
        label: 'สร้างคำสั่งซื้อด่วน',
        value: 'quickOrderV1',
      },
      // {
      //   label: 'สร้างคำสั่งซื้อด่วน V1',
      //   value: 'quickOrderV1',
      // },
      {
        label: 'สร้างคำสั่งซื้อใหม่',
        value: 'createOrder',
      },
      {
        label: 'Import Excel',
        value: 'importExcel',
      },
    ],
  },
  {
    label: 'รายการ คำสั่งซื้อ',
    subject: 'Order',
    fields: [
      {
        label: 'รายการคำสั่งซื้อ AI',
        value: 'ai',
      },
      {
        label: 'รายการคำสั่งซื้อ Telesale',
        value: 'telesaleOrder',
      },
      {
        label: 'รายการคำสั่งซื้อ',
        value: 'myOrder',
      },
      {
        label: 'รายการรอส่งสินค้า',
        value: 'sendOrder',
      },
      {
        label: 'รายการยกเลิก',
        value: 'cancelOrder',
      },
      {
        label: 'รายการสร้าง Tracking',
        value: 'createdTracking',
      },
      {
        label: 'สินค้าตีกลับ',
        value: 'returnProduct',
      },
      {
        label: 'สินค้าตีกลับ (รับสินค้าแล้ว)',
        value: 'returnedProduct',
      },
      {
        label: 'รายการกำลังส่ง',
        value: 'transitOrder',
      },
      {
        label: 'รายการส่งสำเร็จ',
        value: 'deliveredOrder',
      },
      {
        label: 'รายการส่งแล้ว (กำหนดเอง)',
        value: 'successOrder',
      },
    ],
  },
  {
    label: 'รายการคำสั่งซื้อ จาก Platform',
    subject: 'Platform',
    fields: [
      {
        label: 'รายงานยอดขายจาก TikTok',
        value: 'tiktokReport',
      },
      {
        label: 'รายงานยอดขายจาก Shopee',
        value: 'shopeeReport',
      },
    ],
  },
  {
    label: 'รายการ ตั้งค่า',
    subject: 'Setting',
    fields: [
      {
        label: 'ช่องทางการขาย',
        value: 'saleChannel',
      },
      {
        label: 'ตั้งค่าทั่วไป',
        value: 'generalSetting',
      },
      {
        label: 'สมุดที่อยู่',
        value: 'addressBook',
      },
      {
        label: 'ตั้งค่าขนส่ง',
        value: 'shipping',
      },
    ],
  },
  {
    label: 'รายการ สินค้า',
    subject: 'Product',
    fields: [
      {
        label: 'รายการสินค้า',
        value: 'productList',
      },
      {
        label: 'รายงาน ลด-เพิ่ม สินค้า',
        value: 'reportProduct',
      },
      {
        label: 'หมวดหมู่',
        value: 'category',
      },
      {
        label: 'กลุ่มสินค้า',
        value: 'productGroup',
      },
    ],
  },
  {
    label: 'รายการ ค่าใช้จ่าย',
    subject: 'Expense',
    fields: [
      {
        label: 'ค่าใช้จ่าย',
        value: 'expense',
      },
      // {
      //   label: 'ค่าแอด Facebook',
      //   value: 'facebook',
      // },
      // {
      //   label: 'ค่าขนส่ง',
      //   value: 'transport',
      // },
      // {
      //   label: 'ค่าใช้จ่ายอื่นๆ',
      //   value: 'other',
      // },
    ],
  },
  {
    label: 'รายการเลขพัสดุ',
    subject: 'Tracking',
    fields: [
      {
        label: 'สร้างหมายเลขพัสดุ/ พิมพ์ใบลาเบล',
        value: 'create',
      },
      {
        label: 'ประวัติการพิมพ์ใบลาเบล',
        value: 'printed',
      },
    ],
  },
  {
    label: 'รายการ ผู้ใช้งาน',
    subject: 'User',
    fields: [
      {
        label: 'ข้อมูลผู้ใช้งาน',
        value: 'userList',
      },
      // {
      //   label: 'สร้างผู้ใช้งาน',
      //   value: 'create',
      // },
      // {
      //   label: 'แก้ไขข้อมูลผู้ใช้งาน',
      //   value: 'update',
      // },
      // {
      //   label: 'แก้ไขสถานะผู้ใช้งาน',
      //   value: 'updateStatus',
      // },
      // {
      //   label: 'เปลี่ยนรหัสผ่าน',
      //   value: 'changePassword',
      // },
      {
        label: 'รายงานลูกค้า Blacklist',
        value: 'blackList',
      },
      // {
      //   label: 'ข้อมูลลูกค้า',
      //   value: 'customerList',
      // },
    ],
  },
  {
    label: 'ตั้งค่าทั่วไป',
    subject: 'setting',
    fields: [
      {
        label: 'ดาวน์โหลด Excel',
        value: 'downloadExcel',
      },
      {
        label: 'พิมพ์ใบเสร็จ',
        value: 'printReceipt',
      },
    ],
  },
]

export const allowUserNewFeature = ['aaa']
export const allowMerchantNewFeature = ['aaa']

export const isAllowNewFeature = (user: IUser) => {
  return true
  return (
    allowUserNewFeature.includes(user.username) ||
    allowMerchantNewFeature.includes(user.merchantPrefix ?? 'xx')
  )
}

// ฟีเจอร์ TikTok เปิด/ปิดที่ระดับร้าน — แอดมินตั้งค่าจาก dashboard-admin
export const isAllowTikTok = (merchant: IMerchant | any) => {
  return !!merchant?.config?.openTiktok
}

// ฟีเจอร์ Shopee เปิด/ปิดที่ระดับร้าน — สวิตช์เดียวกับ TikTok (dashboard-admin)
export const isAllowShopee = (merchant: IMerchant | any) => {
  return !!merchant?.config?.openShopee
}

// เชื่อมบัญชีแพลตฟอร์มได้เฉพาะเจ้าของร้าน/ผู้ดูแลระบบ พนักงานเชื่อมเองไม่ได้
// ใช้ UserRole (ไม่ใช่ EUserRole) เพราะ EUserRole.SUPER_ADMIN = 'superAdmin'
// ไม่ตรงกับค่าจริงที่ backend ส่งมา ('super_admin')
export const isAllowConnectPlatform = (user: IUser | any) => {
  return !!user?.roles?.some((role: any) =>
    [UserRole.ADMIN, UserRole.MERCHANT, UserRole.SUPER_ADMIN].includes(
      role as UserRole,
    ),
  )
}

export const isAllowConnectTikTok = (
  merchant: IMerchant | any,
  user: IUser | any,
) => {
  return isAllowTikTok(merchant) && isAllowConnectPlatform(user)
}

export const isAllowConnectShopee = (
  merchant: IMerchant | any,
  user: IUser | any,
) => {
  return isAllowShopee(merchant) && isAllowConnectPlatform(user)
}

export const isAllowFacebook = (user: IUser | any) => {
  return user?.roles?.includes('feature_facebook')
}

export const isAllowAi = (user: IUser | any) => {
  return (
    user?.roles?.includes(UserRole.SUPER_ADMIN) ||
    user?.roles?.includes(UserRole.AI) ||
    user?.roles?.includes(UserRole.MERCHANT)
  )
}
